const INITIAL_STATE = {
  subgroupItems: [],
  cart: null,
  payerInfo: null,
  deliveryAddress: null,
  card: null
}

const productsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_SUBGROUP_ITEMS':
      return {
        ...state,
        ...action.subgroupItems
      }
    case 'SET_PRODUCTS_LAST_FETCH':
      return {
        ...state,
        ...action.lastFetch
      }
    case 'SET_CART':
      return {
        ...state,
        ...action.cart
      }
    case 'SET_PAYER_INFO':
      return {
        ...state,
        ...action.payerInfo
      }
    case 'SET_DELIVERY_ADDRESS':
      return {
        ...state,
        ...action.deliveryAddress
      }
    case 'SET_ORDERS':
      return {
        ...state,
        ...action.orders
      }
    default:
      return state
  }
}

export default productsReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/productsReducer.js